import { styleConstants } from '@paywithextend/components'
import { css } from 'styled-components'

// Title + body for the auto-deactivation notice. Color is intentionally NOT
// set here — it inherits from the parent container (yellow alert in step 1,
// severe red banner in step 2). Both lines are microcopy 12/16.
export default css`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .DeactivationNotice-title {
    margin: 0;
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .DeactivationNotice-body {
    margin: 0;
    font-family: ${styleConstants.fontFamilies.regular};
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;
  }
`
